import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { NoteSearchResultItem } from '@nx-frontend/shared/types';
import { SearchNotesPayload } from '@nx-frontend/shared/types';

export async function searchNotes({
  userId,
  workspaceId,
  query,
  buildExcerpts,
  getMatches,
  counters,
}: SearchNotesPayload): Promise<{ entities: NoteSearchResultItem[]; count: number | null }> {
  const host = generalEnv.noteServiceUrl;
  let urlQuery = '?buildExcerpts=';
  urlQuery += buildExcerpts ? 'true' : 'false';
  urlQuery += '&counters=';
  urlQuery += counters ? 'true' : 'false';
  urlQuery += '&getMatches=';
  urlQuery += getMatches ? 'true' : 'false';
  urlQuery += '&query=' + encodeURIComponent(query);
  const response = await axiosClient.get(`${host}/v1/workspaces/${workspaceId}/search/notes/${urlQuery}`, {
    userId,
  });
  return {
    entities: response.data,
    count: counters ? response.headers['x-total-count'] : null,
  };
}
